module.exports = __webpack_public_path__ + "img/ic_24_team_basketball.f36f349c.svg";